import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import EmployeeCard from "../employeeCard/employeeCard";
import { SidebarProps, EmployeeData } from "../../../models/monitorView/monitorViewTypes";
import { useAsyncThunkAction } from "../../../hooks/useAsyncThunkAction";
import { fetchSalaryPeriods, selectSalaryPeriods } from "../../../store/salaryPeriodSlice";
import { handleApiError } from "../../../models/store/storeEffects";
import { fetchSalaryRowTypes, selectSalaryRowTypes } from "../../../store/workShiftTimeSlotSlice";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import { MonitorViewFilters } from "../monitorViewFilters";
import Box from "@mui/material/Box";
import { useFetch } from "../../../hooks/useFetch";
import { getEmployeeGroups } from "../../../services/employeeGroupService";
import { employeeGroupListItemDto } from "../../../models/employeeGroup/employeeGroup";

export const MonitorViewEmployees = ({
    data,
    selectedId: selectedEmployeeId,
    countByWorkTimeType,
    onSelect
}: SidebarProps<EmployeeData> & { onSelect: (id: string) => Promise<void> }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const salaryPeriods = useAppSelector(selectSalaryPeriods);
    const salaryRowTypes = useAppSelector(selectSalaryRowTypes);
    const [employeeGroups, setEmployeeGroups] = useState<employeeGroupListItemDto[]>();

    useAsyncThunkAction(
        () => fetchSalaryPeriods(),
        { onError: (e) => handleApiError(e, dispatch), },
        [],
        !salaryPeriods?.ids?.length
    );

    useAsyncThunkAction(
        () => fetchSalaryRowTypes(),
        { onError: (e) => handleApiError(e, dispatch), },
        [],
        !salaryRowTypes?.length
    );

    useFetch(
        (signal) => getEmployeeGroups(true, signal),
        {
            onSuccess: (res) =>
                setEmployeeGroups(
                    res.data.filter((d) => !!d.salaryPeriodTypeId)
                ),
        },
        []
    );

    return (
        <>
            <Box sx={{ padding: 2 }}>
                <MonitorViewFilters countByWorkTimeType={countByWorkTimeType} />
            </Box>
            {data?.length > 0 ? (
                data.map((e: EmployeeData) => (
                    <EmployeeCard
                        key={e.employeeId}
                        employee={e}
                        employeeGroups={employeeGroups}
                        isSelected={e.employeeId === selectedEmployeeId}
                        onClick={() => {
                            void onSelect(e.employeeId).catch((error) => {
                                console.error("Error selecting employee:", error);
                            });
                        }}
                    />
                ))
            ) : (
                <Alert variant="standard" severity="info">
                    {t("employee.noRows")}
                </Alert>
            )}
        </>
    );
};